import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { useTenant } from '@libs/contexts/TenantContext';
import EventSystemTabLayout from '../../components/layout/EventSystemTabLayout';
import PagingTab from '../../components/admin/tenant/PagingTab';
import SipPagingTab from '../../components/admin/tenant/SipPagingTab';

/**
 * SimpleActionsPage (Paging) - RTP and SIP paging zone configuration.
 * Image Display actions live under Event System > Actions.
 */
const SimpleActionsPage = () => {
  const { selectedTenant } = useTenant();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!selectedTenant) {
    return (
      <EventSystemTabLayout pageTitle="Paging">
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="text.secondary">
            Please select a tenant to configure paging.
          </Typography>
        </Box>
      </EventSystemTabLayout>
    );
  }

  return (
    <EventSystemTabLayout pageTitle="Paging">
      <Box sx={{ width: '100%' }}>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            aria-label="Paging tabs"
          >
            <Tab label="RTP Paging" id="simple-tab-0" aria-controls="simple-tabpanel-0" />
            <Tab label="SIP Paging" id="simple-tab-1" aria-controls="simple-tabpanel-1" />
          </Tabs>
        </Box>

        {/* RTP Paging Tab */}
        <Box
          role="tabpanel"
          hidden={activeTab !== 0}
          id="simple-tabpanel-0"
          aria-labelledby="simple-tab-0"
        >
          {activeTab === 0 && (
            <PagingTab tenantId={selectedTenant?.id} />
          )}
        </Box>

        {/* SIP Paging Tab */}
        <Box
          role="tabpanel"
          hidden={activeTab !== 1}
          id="simple-tabpanel-1"
          aria-labelledby="simple-tab-1"
        >
          {activeTab === 1 && (
            <SipPagingTab tenantId={selectedTenant?.id} />
          )}
        </Box>
      </Box>
    </EventSystemTabLayout>
  );
};

export default SimpleActionsPage;
